import { Route, Routes } from 'react-router'

import { NotFound } from 'js/core/NotFound'

import { ConfirmByEmailPage } from './ConfirmByEmailPage'
import { EventPage } from './EventPage'
import { EventsPage } from './EventsPage'

export const EventsRoutes = () => (
    <Routes>
        <Route index element={<EventsPage />} />
        <Route path="view/:guid" element={<EventPage />} />
        <Route path="view/:guid/:slug" element={<EventPage />} />
        <Route path="confirm/:guid" element={<ConfirmByEmailPage />} />
        <Route path="*" element={<NotFound />} />
    </Routes>
)
